import { tsl_projektdeltagande_tsl_intresseradavstod } from './Generated/tsl_projektdeltagande_tsl_intresseradavstod';

export const InterestedInSupportText: {
  [key in tsl_projektdeltagande_tsl_intresseradavstod]: string;
} = {
  [tsl_projektdeltagande_tsl_intresseradavstod.Tackatja]: 'Tackat ja',
  [tsl_projektdeltagande_tsl_intresseradavstod.Ejintresserad]: 'Ej intresserad',
  [tsl_projektdeltagande_tsl_intresseradavstod.Villavvakta]: 'Vill avvakta',
  [tsl_projektdeltagande_tsl_intresseradavstod.Ejgttattn]: 'Ej gått att nå',
  [tsl_projektdeltagande_tsl_intresseradavstod.Redantillsvidareanstlldpheltid]:
    'Annan pågående tsv-anställning på heltid',
};
